import { Alert, Button, ButtonGroup, Heading, Modal } from '@zillow/constellation-10';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  /** Leaves the AI flow for the standard wizard, rather than only closing the modal. */
  onCompleteManually: () => void;
  /** Absent when the notes are gone, in which case the modal offers the manual form only. */
  onRetry?: () => void;
  isRetrying?: boolean;
};

/** Shown once when the AI draft errors; closing it without choosing leaves the AI flow in place. */
const AiDraftFailedModal = ({ isOpen, onDismiss, onCompleteManually, onRetry, isRetrying = false }: Props) => (
  <Modal
    size="sm"
    dividers={false}
    open={isOpen}
    onOpenChange={(open) => !open && onDismiss()}
    header={
      <Heading level={2} textStyle="heading-xs">
        AI-assisted generation failed
      </Heading>
    }
    body={
      <Alert tone="warning">
        There was an issue processing your photos and notes.{' '}
        {onRetry
          ? 'You can try again, or complete your property description and amenities selection manually.'
          : 'Complete your property description and amenities selection manually.'}
      </Alert>
    }
    footer={
      <ButtonGroup aria-label="Failed draft actions">
        <Button onClick={onCompleteManually} data-testid="ai-draft-complete-manually">
          Complete manually
        </Button>
        {onRetry && (
          <Button loading={isRetrying} emphasis="filled" onClick={onRetry} data-testid="ai-draft-try-again">
            Try again
          </Button>
        )}
      </ButtonGroup>
    }
  />
);

export default AiDraftFailedModal;
